#ifdef GL_ES
precision highp float;
#endif

void main() {
  gl_FragColor = vec4(0.0);
}
